// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/DropdownMenu.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/DropdownMenu.tsx");
  import.meta.hot.lastModified = "1747870550326.369";
}
// REMIX HMR END

import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { forwardRef } from 'react';
import { cn } from '~/utils/style';
const Arrow = forwardRef(_c = ({
  className,
  ...rest
}, ref) => <DropdownMenu.Arrow ref={ref} className={cn('fill-white dark:fill-zinc-600', className)} {...rest} />);
_c2 = Arrow;
Arrow.displayName = 'Arrow';
const Trigger = forwardRef(_c3 = ({
  className,
  ...rest
}, ref) => <DropdownMenu.Trigger ref={ref} className={cn('outline-none', className)} {...rest} />);
_c4 = Trigger;
Trigger.displayName = 'Trigger';
const Content = forwardRef(_c5 = ({
  className,
  ...rest
}, ref) => <DropdownMenu.Content ref={ref} className={cn('min-w-[220px]', 'bg-white', 'dark:bg-zinc-800', 'rounded-md', 'p-1', 'space-y-1', 'shadow-lg', 'ring-1', 'ring-black', 'ring-opacity-5', 'dark:ring-white', 'dark:ring-opacity-10', 'will-change-[opacity,transform]', 'data-[side=top]:animate-slideDownAndFade', 'data-[side=right]:animate-slideLeftAndFade', 'data-[side=bottom]:animate-slideUpAndFade', 'data-[side=left]:animate-slideRightAndFade', className)} {...rest} />);
_c6 = Content;
Content.displayName = 'Content';
const Item = forwardRef(_c7 = ({
  className,
  ...rest
}, ref) => <DropdownMenu.Item ref={ref} className={cn('group', 'text-sm', 'leading-none', 'text-zinc-700', 'dark:text-zinc-200', 'rounded', 'flex', 'items-center', 'relative', 'select-none', 'outline-none', 'data-[disabled]:text-zinc-400', 'data-[disabled]:cursor-not-allowed', 'dark:data-[disabled]:text-zinc-500', 'data-[highlighted]:bg-zinc-100', 'dark:data-[highlighted]:bg-zinc-700', 'data-[highlighted]:text-zinc-900', 'dark:data-[highlighted]:text-zinc-100', className)} {...rest} />);
_c8 = Item;
Item.displayName = 'Item';
export default {
  ...DropdownMenu,
  Arrow,
  Content,
  Item,
  Trigger
};
var _c, _c2, _c3, _c4, _c5, _c6, _c7, _c8;
$RefreshReg$(_c, "Arrow$forwardRef");
$RefreshReg$(_c2, "Arrow");
$RefreshReg$(_c3, "Trigger$forwardRef");
$RefreshReg$(_c4, "Trigger");
$RefreshReg$(_c5, "Content$forwardRef");
$RefreshReg$(_c6, "Content");
$RefreshReg$(_c7, "Item$forwardRef");
$RefreshReg$(_c8, "Item");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;